import React from 'react'

export const InternalServerErrorPage: React.FC = () => (
  <div>
    <h1>internal server error</h1>
  </div>
)
